import * as Types from './actionTypes';

export const startLoading = (key, page = { urls: [] }) => ({
  type: Types.LOADING_STARTED,
  payload: {
    key,
    page,
  },
});

export const doneLoading = (key) => ({
  type: Types.LOADING_DONE,
  payload: {
    key,
  },
});

export const block = (key) => ({
  type: Types.BLOCK,
  payload: {
    key,
  },
});

export const unblock = (key) => ({
  type: Types.UNBLOCK,
  payload: {
    key,
  },
});

export const setCurrentPageTitle = (title) => ({
  type: Types.SET_CURRENT_PAGE_TITLE,
  payload: {
    title,
  },
});
